// Thin wrappers around the /api/branches endpoints. The generic Endpoint
// class doesn't fit because we have sub-paths (/log, /diff, /merge) and the
// payload shapes don't match its CRUD assumptions.

import { fetchData } from '../fetchapi/fetchapi';

export async function listBranches() {
  const res = await fetchData('branches');
  return res.branches || [];
}

export async function createBranch({ name, from = 'main' }) {
  return fetchData('branches', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, from }),
  });
}

export async function deleteBranch(name) {
  return fetchData(`branches/${encodeURIComponent(name)}`, { method: 'DELETE' });
}

export async function getBranchLog(name, limit = 50) {
  const params = new URLSearchParams({ limit: String(limit) });
  const res = await fetchData(`branches/${encodeURIComponent(name)}/log?${params}`);
  return res.commits || [];
}

export async function getBranchDiff(name, against = 'main') {
  const params = new URLSearchParams({ against });
  const res = await fetchData(`branches/${encodeURIComponent(name)}/diff?${params}`);
  return res; // { from, to, tables: [...] }
}

export async function getCommitDiff(branch, hash) {
  return fetchData(`branches/${encodeURIComponent(branch)}/commits/${encodeURIComponent(hash)}/diff`);
}

export async function getCommitTableDiff(branch, hash, table, limit = 100) {
  const params = new URLSearchParams({ limit: String(limit) });
  return fetchData(`branches/${encodeURIComponent(branch)}/commits/${encodeURIComponent(hash)}/diff/${encodeURIComponent(table)}?${params}`);
}

export async function mergeBranch(name, { into = 'main', message, noFastForward = false } = {}) {
  return fetchData(`branches/${encodeURIComponent(name)}/merge`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ into, message, noFastForward }),
  });
}
